import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=32549da0&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=32549da0&scoped=true&lang=css&"
import style1 from "./Messages.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Messages.vue?vue&type=style&index=2&id=32549da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32549da0",
  null
  
)

export default component.exports